import Skeleton from "@mui/material/Skeleton";
import { CircleHelp } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
	Modal,
	ModalTitle,
} from "src/components/Modals/Components/ModalsComponents";
import { ShortLimitedAccess } from "src/components/NewComponents/LimitedAccess";
import { htmlFormatter } from "src/formatters/htmlFormatter";
import { hasLimitedAccess } from "src/helpers/getPermissions";
import { useChatbotInstructions } from "src/hooks/useChatbotInstructions";
import { ModalMaxWidth } from "src/types/enums";

interface ChatbotInstructionsModalProps {
	onClose: () => void;
}

export const ChatbotInstructionsModal = ({
	onClose,
}: ChatbotInstructionsModalProps) => {
	const { t } = useTranslation();
	const { data, isLoading } = useChatbotInstructions();

	if (hasLimitedAccess()) {
		return (
			<Modal onClose={onClose} maxWidth={ModalMaxWidth.sm}>
				<ModalTitle
					title={t("globalChatbot.instructions.title", "Jak używać")}
					Icon={CircleHelp}
				/>
				<ShortLimitedAccess />
			</Modal>
		);
	}

	return (
		<Modal onClose={onClose} maxWidth={ModalMaxWidth.md}>
			<ModalTitle
				title={t("globalChatbot.instructions.title", "Jak używać")}
				Icon={CircleHelp}
			/>
			{isLoading ? (
				<div className="flex flex-col gap-12">
					{Array.from({ length: 4 }).map((_, i) => (
						<Skeleton key={i} variant="rounded" height={24} />
					))}
				</div>
			) : (
				<div className="tiptap-content">{htmlFormatter(data?.html)}</div>
			)}
		</Modal>
	);
};
